import { StyledNav } from "./styles";

import { Link } from "react-scroll";

function NavBar() { 

  return (
    <StyledNav>
      <ul>
        <li><Link to="home" spy={true} smooth={true} offset={50} duration={500} >_home</Link></li>
        <li><Link to="about" spy={true} smooth={true} offset={50} duration={500} >_sobre-mim</Link></li>
        <li><Link to="stack" spy={true} smooth={true} offset={50} duration={500} >_tech-stack</Link></li>
        <li><Link to="projects" spy={true} smooth={true} offset={50} duration={500} >_projetos</Link></li>
        <li><Link to="contact" spy={true} smooth={true} offset={50} duration={500} >_contato</Link></li>
      </ul>
    </StyledNav>
  );
}

export default NavBar;
